export const config = {
  // apiDomains: "http://192.168.0.20:8080",
  // apiDomains: "http://192.168.176.9:8080",
  // apiDomains: "https://api.techsahyadri.com",
  // apiDomains: "http://88.222.215.163:8092",
  // apiDomains: "http://192.168.0.9:8092",
  apiDomains: "https://api.getmyhousing.com",

  defaultMapLocation: {
    latitude: 12.9038631,
    longitude: 77.5855457,
  },
  cookieName: "getmyhousing_user",
  sessionCookie: "getmyhousing_sess",
  preferencesCookie: "getmyhousing_pref",
  leadProvided: "lead_prov",
  mobileNumber1: '9900823404',
  mobileNumber2: '9900127096',
  whatsappNumber: "9686522212",
};
